<script setup>
defineProps({
  metCount: {
    type: Number,
    default: 0,
  },
  missedCount: {
    type: Number,
    default: 0,
  },
});
</script>

<template>
  <div class="flex flex-col w-full gap-2">
    <span class="text-sm font-medium text-n-slate-12">
      {{ $t('CUSTOM_SLA.EVENTS.NEXT_RESPONSE') }}
    </span>
    <div class="flex justify-between w-full pl-2">
      <span
        class="text-sm font-normal tracking-[-0.6%] min-w-[140px] truncate text-n-slate-11"
      >
        {{ $t('CUSTOM_SLA.EVENTS.NEXT_RESPONSE_MET') }}
      </span>
      <span class="text-sm font-medium text-right tabular-nums text-n-teal-11">
        {{ metCount }}
      </span>
    </div>
    <div class="flex justify-between w-full pl-2">
      <span
        class="text-sm font-normal tracking-[-0.6%] min-w-[140px] truncate text-n-slate-11"
      >
        {{ $t('CUSTOM_SLA.EVENTS.NEXT_RESPONSE_MISSED') }}
      </span>
      <span class="text-sm font-medium text-right tabular-nums text-n-ruby-11">
        {{ missedCount }}
      </span>
    </div>
  </div>
</template>
